import React, { useContext } from "react";

import { NavLink } from "react-router-dom";
// import PhoneIcon from "@mui/icons-material/Phone";

import { navigationLinks } from "../popData";
import { SlidersContext } from "../providers/SlidersProvider";
import {
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
} from "@mui/icons-material";
// import { SlidersContext } from "../providers/SlidersProvider";

const NavBar = (props) => {
  const { sliders, closeSlider } = useContext(SlidersContext);

  return (
    <div className="headerBar mobile-hide">
      <nav className="navBar mobile-hide">
        <div className="navLinks">
          {navigationLinks.map((navLink, i) => {
            return (
              <NavLink
                key={i}
                activeClassName="activeLink"
                exact
                isActive={(match, location) => {
                  if (match) return true;

                  if (location.pathname.includes(navLink.matcher)) return true;

                  return false;
                }}
                to={(location) => {
                  // debugger;
                  // Remove slider if navigating to the page you are already on
                  if (sliders && location.pathname === navLink.path) {
                    closeSlider();
                  }

                  return {
                    ...location,
                    pathname: navLink.path,
                    state: { preservePrimary: false },
                  };
                }}
              >
                {navLink.label}
              </NavLink>
            );
          })}

          <NavLink activeClassName="activeLink" to="/phone">
            <PhoneIcon style={{ fontSize: "18px", marginTop: "2px" }} />
          </NavLink>

          {/* <NavLink activeClassName="activeLink" to="/tom-tom-map">
            <LocationOnIcon style={{ fontSize: "18px", marginTop: "2px" }} />
          </NavLink> */}
        </div>

        <button className="signOut" onClick={props.signOutGoogle}>
          Sign Out
        </button>
      </nav>
    </div>
  );
};

export default NavBar;
